export interface Buyer {
  name: string
  city: string
  country: string
  flag: string
}

export const buyers: Buyer[] = [
  { name: 'Ryan C.', city: 'Phoenix, AZ', country: 'United States', flag: '🇺🇸' },
  { name: 'Emily W.', city: 'Manchester', country: 'United Kingdom', flag: '🇬🇧' },
  { name: 'Noah B.', city: 'Vancouver', country: 'Canada', flag: '🇨🇦' },
  { name: 'Jack T.', city: 'Perth', country: 'Australia', flag: '🇦🇺' },
  { name: 'Michael R.', city: 'Dallas, TX', country: 'United States', flag: '🇺🇸' },
  { name: 'Harry P.', city: 'Edinburgh', country: 'United Kingdom', flag: '🇬🇧' },
  { name: 'Olivia M.', city: 'Toronto', country: 'Canada', flag: '🇨🇦' },
  { name: 'Lachlan S.', city: 'Melbourne', country: 'Australia', flag: '🇦🇺' },
  { name: 'Tyler J.', city: 'Orlando, FL', country: 'United States', flag: '🇺🇸' },
  { name: 'George H.', city: 'Bristol', country: 'United Kingdom', flag: '🇬🇧' },
  { name: 'Ethan L.', city: 'Calgary', country: 'Canada', flag: '🇨🇦' },
  { name: 'Mia K.', city: 'Brisbane', country: 'Australia', flag: '🇦🇺' },
]
